import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const isContactWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  filterItem.type === 'select_for_conversation_contact' &&
  !!filterItem.config.is_values_required &&
  !filterItem.config.values.length
